import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CardRefreshDirective } from './components/card/card-refresh.directive';
import { CardToggleDirective } from './components/card/card-toggle.directive';
import { CardComponent } from './components/card/card.component';
import { TranslatePipe } from './pipes/translate.pipe';
import { ModalBasicComponent } from './components/modal-basic/modal-basic.component';
import { NumericDirective } from './services/numeric.service';
import { TimeagoModule } from 'ngx-timeago';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyPipe } from './pipes/empty.pipe';
import { EmailPipe } from './pipes/email.pipe';
import { TrimPipe } from './pipes/trim.pipe';
import { HasAuthorityPipe } from './pipes/has-authority.pipe';
import { RoleKeyPipe } from './pipes/role-key.pipe';
import { RoleGroupPipe } from './pipes/role-group.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { CustomNgxLoadingComponent } from './components/custom-ngx-loading/custom-ngx-loading.component';
import { KpiExpertDashboardComponent } from './components/kpi-expert-dashboard/kpi-expert-dashboard.component';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { OrderPipe } from './pipes/order.pipe';
import { ConcatPipe } from './pipes/concat.pipe';
import { SecureImageComponent } from './components/secure-image/secure-image.component';
import { SecureRessourcePipe } from './pipes/secure-ressource.pipe';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { InViewportModule } from 'ng-in-viewport';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { StripTextPipe } from './pipes/strip-text.pipe';
import { UriPipe } from './pipes/uri.pipe';
import { FormatOutputPipe } from './pipes/format-output.pipe';
import { FormatPlatePipe } from './pipes/format-plate.pipe';
import { WindowComponent } from './components/window/window.component';
import { PortalModule } from '@angular/cdk/portal';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorLightPipe } from './pipes/color-light.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { DocumentDisplayComponent } from './components/document-display/document-display-component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RemoveCommaPipe } from './pipes/remove-comma.pipe';
import { EpochDatePipe } from './pipes/epoch-date.pipe';
import { SpaceSeparatorPipe } from './pipes/space-separator.pipe';
import { KpiChartComponent } from './components/kpi-chart/kpi-chart.component';

const EXPORTED_DECLARATIONS = [
  CardRefreshDirective,
  CardToggleDirective,
  TranslatePipe,
  NumericDirective,
  CardComponent,
  ModalBasicComponent,
  EmptyPipe,
  EmailPipe,
  TrimPipe,
  HasAuthorityPipe,
  RoleKeyPipe,
  RoleGroupPipe,
  FilterPipe,
  ConcatPipe,
  OrderPipe,
  SecureRessourcePipe,
  CustomNgxLoadingComponent,
  KpiExpertDashboardComponent,
  KpiChartComponent,
  DateFormatPipe,
  StripTextPipe,
  UriPipe,
  FormatOutputPipe,
  FormatPlatePipe,
  WindowComponent,
  SecureImageComponent,
  WindowComponent,
  SafeHtmlPipe,
  DocumentDisplayComponent,
  RemoveCommaPipe,
  EpochDatePipe,
  SpaceSeparatorPipe,
];

@NgModule({
  declarations: [...EXPORTED_DECLARATIONS, ColorLightPipe, SpaceSeparatorPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TimeagoModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(255,255,255,0.95)',
      backdropBorderRadius: '5px',
      primaryColour: '#fd5621',
      secondaryColour: '#0f7d70',
      tertiaryColour: '#fd5621',
    }),
    LazyLoadImageModule,
    InViewportModule,
    PortalModule,
    LoadingBarModule,
    NgbProgressbarModule,
    TimeagoModule,
    PdfViewerModule,
  ],
  exports: [...EXPORTED_DECLARATIONS, ColorLightPipe],
})
export class SharedModule {}
